import './index.css';
import { useEffect, useState } from 'react';
import { View, Text, GadgetLeague } from '../../../component';
import useTheme from '../../../utilities/hooks/theme';
import React from 'react';
import { convertToDollars, isSmartPhone } from '../../../utilities/helper';
import ContestDetailsWinningBreakupMWeb from './index_mWeb';
interface Props {
  winningData?: any;
  isGadgetLeague?: boolean;
  description?: string | undefined;
}
const ContestDetailsWinningBreakup = ({
  winningData,
  isGadgetLeague = false,
  description = ''
}: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const [winningBreakUpList, setWinningBreakUpList] = useState([] as any);
  useEffect(() => {
    if (winningData) {
      let winningBreakUpList: any[] = [];
      Object.entries(winningData).map(([key, myValue]) => {
        winningBreakUpList.push({
          key: key,
          value: myValue
        });
      });

      winningBreakUpList.sort((a, b) => {
        return parseInt(a.key.split('-')[0]) - parseInt(b.key.split('-')[0]);
      });
      setWinningBreakUpList(winningBreakUpList);
    }
  }, [winningData]);

  const tabTextColor = {
    color: theme.contestDetailsTabHeaderText
  };

  const rowStyle = {
    borderBottom: `1px solid ${theme.contestCardBorder}`,
    borderLeft: `1px solid ${theme.contestCardBorder}`,
    borderRight: `1px solid ${theme.contestCardBorder}`,
    background: theme.contestWinningBreakUpRowBg
  };
  const rowHeaderStyle = {
    border: `1px solid ${theme.contestCardBorder}`,
    background: theme.contestWinningBreakUpHeaderBg,
    boxShadow: theme.contestWinningBreakUpHeaderBoxShadow
  };

  if (isSmartPhone) {
    return (
      <ContestDetailsWinningBreakupMWeb
        winningData={winningData}
        isGadgetLeague={isGadgetLeague}
        description={description}
      />
    );
  }
  const colItemStyle = {
    width: '50%',
    height: '100%',
    display: 'flex',
    alignItems: 'center'
  };
  const renderItem = (item: any) => {
    const { key = '', value = '' } = item;
    return (
      <View className={'contest-winning-breakup-row'} key={key} style={rowStyle}>
        <div style={{ ...colItemStyle, borderRight: `1px solid ${theme.contestCardBorder}` }}>
          <Text
            className={'contest-winning-breakup-row-tab-text'}
            style={{ color: '#fff' }}>{`#${key}`}</Text>
        </div>
        {isGadgetLeague ? (
          <GadgetLeague
            containerStyle={{ flex: 1 }}
            titleClassName="contest-winning-breakup-row-tab-prize"
            titleStyle={tabTextColor}
            description={description}
          />
        ) : (
          <div style={colItemStyle}>
            <Text
              className={'contest-winning-breakup-row-tab-text'}
              style={{ color: '#fff' }}>{`${convertToDollars(value / 100)}`}</Text>
          </div>
        )}
      </View>
    );
  };

  return (
    <View className={'contest-winning-breakup-container'}>
      <View className={'contest-winning-breakup-header'} style={rowHeaderStyle}>
        <div style={{ ...colItemStyle, borderRight: `1px solid ${theme.contestCardBorder}` }}>
          <Text className={'contest-winning-breakup-header-title'} style={tabTextColor}>
            {'Rank'}
          </Text>
        </div>
        <div style={colItemStyle}>
          <Text className={'contest-winning-breakup-header-title'} style={tabTextColor}>
            {'Prize'}
          </Text>
        </div>
      </View>
      {winningBreakUpList.map((item: any) => renderItem(item))}
    </View>
  );
};
ContestDetailsWinningBreakup.defaultProps = {
  isGadgetLeague: false
};
export default React.memo(ContestDetailsWinningBreakup);
